/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1LocationStatesId202,
  PutApiV1LocationStatesId400,
  PutApiV1LocationStatesId401,
  PutApiV1LocationStatesId404,
  PutApiV1LocationStatesId409,
  PutApiV1LocationStatesId500,
  PutApiV1LocationStatesIdMutationRequest,
  PutApiV1LocationStatesIdMutationResponse,
  PutApiV1LocationStatesIdPathParams,
} from "../../types/locationStateController/PutApiV1LocationStatesId.ts";
import { stateViewModelSchema } from "../stateViewModelSchema.ts";
import { updateStateRequestViewModelSchema } from "../updateStateRequestViewModelSchema.ts";

export const putApiV1LocationStatesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1LocationStatesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1LocationStatesId202Schema = z.lazy(
  () => stateViewModelSchema,
) as unknown as ToZod<PutApiV1LocationStatesId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1LocationStatesId400Schema =
  z.any() as unknown as ToZod<PutApiV1LocationStatesId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1LocationStatesId401Schema =
  z.any() as unknown as ToZod<PutApiV1LocationStatesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1LocationStatesId404Schema =
  z.any() as unknown as ToZod<PutApiV1LocationStatesId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1LocationStatesId409Schema =
  z.any() as unknown as ToZod<PutApiV1LocationStatesId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1LocationStatesId500Schema =
  z.any() as unknown as ToZod<PutApiV1LocationStatesId500>;

export const putApiV1LocationStatesIdMutationRequestSchema = z.lazy(
  () => updateStateRequestViewModelSchema,
) as unknown as ToZod<PutApiV1LocationStatesIdMutationRequest>;

export const putApiV1LocationStatesIdMutationResponseSchema = z.lazy(
  () => putApiV1LocationStatesId202Schema,
) as unknown as ToZod<PutApiV1LocationStatesIdMutationResponse>;
